import React, { PropTypes } from 'react'
import { DayPicker } from 'react-dates'
import CSSModules from 'react-css-modules'

import Button from 'components/grid-form-button'

import styles from './single-date-picker.css'

const SingleDatePicker = ({ dates, format, onDayClick, onContinue }) => (
  <div styleName="single-date-picker">
    <DayPicker
      modifiers={{
        selected: date => dates.indexOf(format(date)) > -1,
        weekend: date => date.day() === 6 || date.day() === 0,
      }}
      numberOfMonths={2}
      onDayClick={onDayClick}
    />
    <div styleName="actions">
      <Button name="Save" onClick={onContinue} />
    </div>
  </div>
)

SingleDatePicker.propTypes = {
  dates: PropTypes.array.isRequired,
  format: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onDayClick: PropTypes.func.isRequired,
}

export default CSSModules(SingleDatePicker, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/single-date-picker/single-date-picker.js
 **/